import { debounce } from '../utils/utils'

class ThirdParty {
  constructor(target, callback, config = {}) {
    this.callback = callback
    this.target =
      typeof target === 'string' ? document.querySelector(target) : target

    this.props = {
      isLoaded: false,
      onScrolling: config.onScrolling || false,
      isFullyVisible: config.isFullyVisible || false,
      minimumScrollPixels: config.minimumScrollPixels || 100,
    }

    if (
      (!this.target || typeof this.callback !== 'function') &&
      !this.props.onScrolling
    ) {
      console.log('target or callback does not exist')
      return
    }

    this.props.onScrolling ? this.onScrolling() : this.intersectionViewport()
  }

  onScrolling() {
    this.scrolling = debounce(() => {
      if (
        !this.props.isLoaded &&
        window.scrollY > this.props.minimumScrollPixels
      ) {
        this.props.isLoaded = true
        window.removeEventListener('scroll', this.scrolling)

        this.callback(this.target)
      }
    })

    window.addEventListener('scroll', this.scrolling)
  }

  intersectionViewport() {
    if ('IntersectionObserver' in window) {
      const threshold = this.props.isFullyVisible ? 1 : 0
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entrie) => {
            if (entrie.isIntersecting) {
              this.callback(this.target)
              observer.unobserve(this.target)
            }
          })
        },
        { threshold }
      )

      observer.observe(this.target)
    } else {
      console.warn('not support IntersectionObserver')
    }
  }
}

export default ThirdParty
